
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { PhotoCard } from "../../components/PhotoCard";
import { Challenge as ChallengeType } from "../../lib/types";

type Props = {
  challenge: ChallengeType;
  user: any;
  hill: any;
  currentChallenger: any;
  isVoting: boolean;
  onHillVote: (winnerId: string) => void;
};

export function KingOfTheHillSection({
  challenge, user, hill, currentChallenger, isVoting, onHillVote
}: Props) {
  return (
    <section className="space-y-5 mb-6">
      <h2 className="text-2xl font-bold text-bauhaus-darkgreen font-['Bebas_Neue'] tracking-wide mb-2">
        King of the Hill: Pick the winner!
      </h2>
      <p className="text-bauhaus-green text-lg mb-4">
        Today's prompt: {challenge.selectedPrompt?.text}
      </p>
      {user && hill && currentChallenger ? (
        <div className="flex flex-row gap-6 w-full justify-center">
          {/* Hill (left) */}
          <div className="w-1/2 flex flex-col items-center">
            <PhotoCard
              submission={hill}
              isVoted={false}
              onVote={() => onHillVote(hill.id)}
            />
            <Button
              onClick={() => onHillVote(hill.id)}
              className="w-full mt-3"
              disabled={isVoting}
            >
              {isVoting ? (
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              ) : "👑 Keep Hill"}
            </Button>
          </div>
          {/* Challenger (right) */}
          <div className="w-1/2 flex flex-col items-center">
            <PhotoCard
              submission={currentChallenger}
              isVoted={false}
              onVote={() => onHillVote(currentChallenger.id)}
            />
            <Button
              onClick={() => onHillVote(currentChallenger.id)}
              className="w-full mt-3"
              disabled={isVoting}
            >
              {isVoting ? (
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              ) : "👋 Take Over"}
            </Button>
          </div>
        </div>
      ) : (
        <div className="bg-bauhaus-green border-2 border-bauhaus-darkgreen rounded-lg p-7 text-center">
          <h3 className="text-lg font-medium mb-2 text-bauhaus-offwhite">Thanks for voting!</h3>
          <p className="text-bauhaus-offwhite/90">
            Check back after voting ends to see the winner.
          </p>
        </div>
      )}
    </section>
  );
}
